import { useState, useEffect, useRef } from "react";
import { Bell } from "lucide-react";
import { db, auth } from "../firebase";
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  updateDoc,
  doc,
  writeBatch,
} from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";

export default function NotificationButton() {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [userId, setUserId] = useState(null);

  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  // Lấy user hiện tại
  useEffect(() => {
    return onAuthStateChanged(auth, (user) => {
      setUserId(user ? user.uid : null);
    });
  }, []);

  // Lắng nghe thông báo thay đổi
  useEffect(() => {
    if (!userId) return;

    const q = query(
      collection(db, `users/${userId}/notifications`),
      orderBy("createdDate", "desc")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setNotifications(data);
      setUnreadCount(data.filter((n) => !n.seen).length);
    });

    return () => unsubscribe();
  }, [userId]);

  // Đóng dropdown khi click ra ngoài
  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // BẤM NOTIFICATION BUTTON → set seen = true cho toàn bộ
  const handleToggleDropdown = async () => {
    const newState = !open;
    setOpen(newState);

    // Chỉ update nếu mở dropdown và có unread
    if (newState && unreadCount > 0 && userId) {
      const batch = writeBatch(db);

      notifications.forEach((n) => {
        if (!n.seen) {
          batch.update(doc(db, `users/${userId}/notifications`, n.id), {
            seen: true,
          });
        }
      });

      await batch.commit();
    }
  };

  // Click từng notification
  const handleClickNotification = async (n) => {
    if (!userId) return;

    // await updateDoc(
    //   doc(db, `users/${userId}/notifications`, n.id),
    //   { seen: true }
    // );

    if (n.postId) {
      navigate(`/post/${n.postId}/0`);
      setOpen(false);
    }
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        className="relative bg-white hover:opacity-90 text-election-primary px-1 py-1 rounded flex items-center justify-center"
        onClick={handleToggleDropdown}
      >
        <Bell className="w-6 h-6" />
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-election-primary text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center border border-white">
            {unreadCount}
          </span>
        )}
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-lg border z-50 max-h-96 overflow-y-auto">
          <div className="p-3 border-b font-semibold">Thông báo</div>

          {notifications.length === 0 ? (
            <div className="p-4 text-gray-500 text-sm text-center">
              Không có thông báo
            </div>
          ) : (
            notifications.map((n) => (
              <div
                key={n.id}
                onClick={() => handleClickNotification(n)}
                className={`p-3 cursor-pointer hover:bg-gray-100 ${!n.seen ? "bg-gray-50 font-medium" : ""
                  }`}
              >
                <div className="text-sm">{n.title || "Thông báo"}</div>
                <div
                  className="text-xs text-gray-500 line-clamp-3"
                >
                  {n.body || "Bạn có một thông báo mới"}
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
